import { render, staticRenderFns } from "./metodologia-identificacion.vue?vue&type=template&id=b581cea4&scoped=true&"
import script from "./metodologia-identificacion.vue?vue&type=script&lang=js&"
export * from "./metodologia-identificacion.vue?vue&type=script&lang=js&"
import style0 from "./metodologia-identificacion.vue?vue&type=style&index=0&id=b581cea4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b581cea4",
  null
  
)

export default component.exports